import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDInsured  {
    _originalTypeClassName = "zERP.BO.APDInsured";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDInsured.translate = translateService;
}
this.APDInsurance = [];
this.Id = null;
this.RecordType = null;
this.RegistrationNumber = null;
this.AMKA = null;
this.LastName = null;
this.FirstName = null;
this.FatherName = null;
this.MotherName = null;
this.Birthday = null;
this.AFM = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RecordType:any;
RegistrationNumber:any;
AMKA:any;
LastName:any;
FirstName:any;
FatherName:any;
MotherName:any;
Birthday:any;
AFM:any;
APDInsurance:any;
static setAPDInsurance = ($this, items) => {
                if (items == null) items = [];
                if ($this.APDInsurance == null) $this.APDInsurance = [];

                const copyItems = Common.cloneObject(items);

                while ($this.APDInsurance.length > 0) {
                    Domain.APDInsured.removeAPDInsurance($this, $this.APDInsurance[0]);
                }

                Domain.APDInsured.addManyAPDInsurance($this, copyItems);
            }
static addManyAPDInsurance = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.APDInsured.addAPDInsurance($this, items[i]);
                }
            }
static addAPDInsurance = ($this, item) => {
                if ($this.APDInsurance == null) $this.APDInsurance = [];
                if (item == null || $this.APDInsurance.indexOf(item) > -1) return;
                $this.APDInsurance.push(item);
}
static addRangeAPDInsurance = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.APDInsured.addAPDInsurance($this, item));
            }
static removeAPDInsurance = ($this, item) => {
                if ($this == null || $this.APDInsurance == null || $this.APDInsurance.indexOf(item) === -1) return;
                var _index = $this.APDInsurance.indexOf(item);
                $this.APDInsurance.splice(_index, 1);
}
static clearAPDInsurance = ($this) => { $this.APDInsurance = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}